import { Button, Chip, Input, Stack, Typography } from "@mui/material";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";

const EnglishTestPage = () => {
  const [clicked, setClicked] = useState(false);
  const [text, setText] = useState(null);

  const navigate = useNavigate();

  const [ielts, setielts] = useState(false);
  const [tofel, settofel] = useState(false);
  const [pte, setpte] = useState(false);
  const [none, setnone] = useState(false);

  const [errielts, seterrielts] = useState(false);
  const [errtofel, seterrtofel] = useState(false);
  const [errpte, seterrpte] = useState(false);
  //const [errielts , seterrielts] = useState('');

  const handleClick = (e) => {
    setClicked(true);
    setText(e.target.innerHTML);
    console.log(e.target.innerHTML);
    console.info("You clicked the Chip.");
  };

  const handleClickielts = () => {
    setielts(true);
    settofel(false);
    setpte(false);
    setnone(false);
    seterrielts(false);
    // setClicked(true);
  };

  const handleClicktofel = () => {
    setielts(false);
    settofel(true);
    setpte(false);
    setnone(false);
    seterrielts(false);
    // setClicked(true);
  };

  const handleClickpte = () => {
    setielts(false);
    settofel(false);
    setpte(true);
    setnone(false);
    seterrielts(false);
    // setClicked(true);
  };

  const handleClicknone = () => {
    setielts(false);
    settofel(false);
    setpte(false);
    setnone(true);
    seterrielts(true);
    // setClicked(true);
  };

  const handleieltsscore = (e) => {
    if (e.target.value >= 0 && e.target.value <= 9) {
      seterrielts(true);
    } else {
      seterrielts("IELTS  score must be in between 0-9");
    }
  };

  const handletofelscore = (e) => {
    if (e.target.value >= 0 && e.target.value <= 120) {
      seterrtofel(true);
    } else {
      seterrtofel("TOEFL  score must be in between 0-120");
    }
  };

  const handleptescore = (e) => {
    if (e.target.value >= 10 && e.target.value <= 90) {
      seterrpte(true);
    } else {
      seterrpte("PTE  score must be in between 10-90");
    }
  };

  const handleClickButton = () => {
    navigate("/academictest");
  };

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <div>
                  <Typography color="secondary"
                    fontSize={28}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                    Which english language test have you taken OR are planning
                    to take?
                  </Typography>
                </div>
                <div className="p-20 flex items-center justify-center ">
                <Stack direction="row" spacing={1}className="crad equalMargin">
                  <Chip
                    className="p-20 mx-10 rounded-full font-bold border-3 text-14"
                    sx={{fontSize:"18px", color:"white"}}
                    size="medium"
                    label="IELTS"
                    style={{
                      backgroundColor: ielts ? "#603aa2" : "#c59bdb",
                      size: "100px",
                    }}
                    variant={ielts ? "filled" : "outlined"}
                    onClick={(e) => handleClickielts(e)}
                  />
                  <Chip
                    className="p-20 rounded-full font-bold border-3 text-14"
                    sx={{fontSize:"18px", color:"white"}}
                    label="TOFEL"
                    size="medium"
                    style={{ backgroundColor: tofel ? "#603aa2" : "#c59bdb" }}
                    variant={tofel ? "filled" : "outlined"}
                    onClick={(e) => handleClicktofel(e)}
                  />
                  <Chip
                    className="p-20 mx-10 rounded-full font-bold border-3 text-14"
                    sx={{fontSize:"18px", color:"white"}}
                    label="PTE"
                    size="medium"
                    style={{ backgroundColor: pte ? "#603aa2" : "#c59bdb" }}
                    variant={pte ? "filled" : "outlined"}
                    onClick={(e) => handleClickpte(e)}
                  />
                  <Chip
                    className="p-20 rounded-full font-bold border-3 text-14"
                    sx={{fontSize:"18px", color:"white"}}
                    label="Not Planning To Take Any"
                    size="medium"
                    style={{ backgroundColor: none ? "#603aa2" : "#c59bdb" }}
                    variant={none ? "filled" : "outlined"}
                    onClick={(e) => handleClicknone(e)}
                  />
                  </Stack>
                </div>

                {ielts && (
                  <>
                    <div>
                      <Typography color="secondary"
                    fontSize={20}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        Enter your score
                      </Typography>
                    </div>
                    <div className="flex  flex-col justify-center">
                      <center>
                        <Input
                          type="number"
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#5D3FD3",
                          }}
                          onChange={(e) => handleieltsscore(e)}
                        ></Input>
                      </center>
                      <Typography color="secondary"
                       fontSize={15}
                       align="center"
                        className="mt-5 flex justify-center  text-[#5D3FD3] text-red font-bold">
                        {errielts}
                      </Typography>
                    </div>
                  </>
                )}

                {tofel && (
                  <>
                    <div>
                      <Typography 
                      color="secondary"
                      fontSize={20}
                      align="center"
                      className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        Enter your score
                      </Typography>
                    </div>
                    <div className="flex flex-col justify-center">
                      <center>
                        <Input
                          type="number"
                          onChange={(e) => handletofelscore(e)}
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#5D3FD3",
                          }}
                        ></Input>
                      </center>
                      <Typography
                       color="secondary"
                       fontSize={15}
                       align="center"
                        className="mt-5 flex justify-center  text-[#5D3FD3] text-red font-bold">
                        {errtofel}
                      </Typography>
                    </div>
                  </>
                )}

                {pte && (
                  <>
                    <div>
                      <Typography 
                      color="secondary"
                    fontSize={15}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        Enter your score
                      </Typography>
                    </div>
                    <div className="flex flex-col justify-center">
                      <center>
                        <Input
                          type="number"
                          onChange={(e) => handleptescore(e)}
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#5D3FD3",
                          }}
                        ></Input>
                      </center>
                      <Typography  color="secondary"
                    fontSize={15}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                        {errpte}
                      </Typography>
                    </div>
                  </>
                )}

                {/* {ielts && (
          <>
            <div>
              <Typography className="p-20 text-blue font-bold text-20 flex justify-center">
                Enter your score
              </Typography>
            </div>
            <div className="flex justify-center">
              <Input type="number"></Input>
            </div>
          </>
        )} */}

                <div className="d-flex mt-5 items-center  justify-center crad equalMargin">
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleClickButton}
                    style={{ backgroundColor: "#603aa2" }}
                    //  disabled={err}
                    disabled={
                      errielts == true || errtofel == true || errpte == true
                        ? false
                        : true
                    }
                    color="primary"
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default EnglishTestPage;
